import { styled } from '@mui/material';
import { LoadingButton } from '@mui/lab';

import { varAlpha } from 'src/theme/styles';

interface ButtonProps {
  noFill?: boolean;
}

const styledButton: React.CSSProperties = {
  boxShadow: 'none',
  textTransform: 'none',
  fontSize: '0.875rem',
  fontWeight: 600,
  padding: '6px 12px',
  border: '1px solid',
  lineHeight: 1.5,
  maxWidth: 'unset',
};

export const ButtonContained = styled(LoadingButton, {
  shouldForwardProp: (prop) => prop !== 'noFill',
})<ButtonProps>(({ theme, noFill }) => ({
  backgroundColor: noFill ? theme.vars.palette.common.white : theme.vars.palette.primary.main,
  borderColor: theme.vars.palette.primary.main,
  color: noFill ? theme.vars.palette.primary.main : theme.vars.palette.common.white,
  ...styledButton,
  '&:hover': {
    backgroundColor: noFill ? theme.vars.palette.primary.main : theme.vars.palette.common.white,
    color: noFill ? theme.vars.palette.common.white : theme.vars.palette.primary.main,
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
  },
  '&:focus': {
    boxShadow: varAlpha(theme.vars.palette.primary.mainChannel, 0.17),
  },
}));
export const ButtonOutline = styled(LoadingButton)(({ theme }) => ({
  ...styledButton,
  backgroundColor: theme.vars.palette.common.white,
  borderColor: theme.vars.palette.primary.main,
  color: theme.vars.palette.primary.main,
  '&:hover': {
    backgroundColor: varAlpha(theme.vars.palette.primary.mainChannel, 0.17),
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
  },
  '&:focus': {
    boxShadow: varAlpha(theme.vars.palette.primary.mainChannel, 0.17),
  },
  whiteSpace: 'nowrap',
}));

export const ButtonDashed = styled(LoadingButton)(({ theme }) => ({
  ...styledButton,
  borderStyle: 'dashed',
  backgroundColor: theme.vars.palette.common.white,
  borderColor: theme.vars.palette.primary.main,
  color: theme.vars.palette.primary.main,
  minWidth: 10,
  '&:hover': {
    backgroundColor: varAlpha(theme.vars.palette.primary.mainChannel, 0.17),
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
  },
  '&:focus': {
    boxShadow: varAlpha(theme.vars.palette.primary.mainChannel, 0.17),
  },
  whiteSpace: 'nowrap',
}));

export const ButtonDanger = styled(LoadingButton)(({ theme }) => ({
  backgroundColor: theme.vars.palette.error.main,
  borderColor: theme.vars.palette.error.main,
  color: theme.vars.palette.common.white,
  ...styledButton,
  '&:hover': {
    backgroundColor: theme.vars.palette.common.white,
    color: theme.vars.palette.error.main,
    boxShadow: 'none',
  },
  '&:active': {
    boxShadow: 'none',
  },
}));

export const BaseButton = styled(LoadingButton)<{ filled?: boolean }>(({ theme, filled }) => ({
  backgroundColor: filled ? theme.palette.primary.main : theme.palette.common.white,
  color: filled ? `${theme.palette.primary.contrastText}` : theme.palette.primary.main,
  border: `1px solid ${theme.palette.primary.main}`,
  '&:hover': {
    background: `${filled ? theme.palette.primary.contrastText : theme.palette.primary.main}`,
    border: `1px solid ${theme.palette.primary.main}`,
    color: `${filled ? theme.palette.primary.main : theme.palette.primary.contrastText}`,
  },
}));
